import { render } from "./HiTabGroup.vue?vue&type=template&id=7a48658e"
import script from "./HiTabGroup.vue?vue&type=script&lang=js"
export * from "./HiTabGroup.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__